import { render, staticRenderFns } from "./wentizu.vue?vue&type=template&id=70ab3378&"
import script from "./wentizu.vue?vue&type=script&lang=ts&"
export * from "./wentizu.vue?vue&type=script&lang=ts&"
import style0 from "./wentizu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports